import _snakeCase from "lodash/snakeCase";
import * as React from 'react';
import classnames from 'classnames';
import GLOBALS from '../../styles/defaultGlobals';
import inject from '../../jss/index';
import styles from './Column.jss';
var COLUMNS = GLOBALS.getIn(['sizes', 'columns']);
export var cn = function cn(bp, cols, classes, key) {
  var output = "".concat(key, "-").concat(_snakeCase(bp), "-").concat(String(cols));
  if (cols) {
    return output in classes ? classes[output] : '';
  }
  return cols;
};
export var Column = function Column(_ref) {
  var children = _ref.children,
    mobile = _ref.mobile,
    tablet = _ref.tablet,
    laptop = _ref.laptop,
    desktop = _ref.desktop,
    desktopLarge = _ref.desktopLarge,
    phone = _ref.phone,
    small = _ref.small,
    medium = _ref.medium,
    large = _ref.large,
    pushMobile = _ref.pushMobile,
    pushTablet = _ref.pushTablet,
    pushLaptop = _ref.pushLaptop,
    pushDesktop = _ref.pushDesktop,
    pushDesktopLarge = _ref.pushDesktopLarge,
    xsOffset = _ref.xsOffset,
    smOffset = _ref.smOffset,
    mdOffset = _ref.mdOffset,
    lgOffset = _ref.lgOffset,
    dlgOffset = _ref.dlgOffset,
    classes = _ref.classes,
    className = _ref.className,
    style = _ref.style;
  var gridClassNames = classnames(cn('mobile', mobile || phone, classes, 'Column'), cn('tablet', tablet || small, classes, 'Column'), cn('laptop', laptop || medium, classes, 'Column'), cn('desktop', desktop || large, classes, 'Column'), cn('desktopLarge', desktopLarge, classes, 'Column'));
  var pushClassNames = classnames(cn('mobile', pushMobile || xsOffset, classes, 'Push'), cn('tablet', pushTablet || smOffset, classes, 'Push'), cn('laptop', pushLaptop || mdOffset, classes, 'Push'), cn('desktop', pushDesktop || lgOffset, classes, 'Push'), cn('desktopLarge', pushDesktopLarge || dlgOffset, classes, 'Push'));
  var classNames = classnames(gridClassNames, pushClassNames, className);
  return React.createElement("div", {
    style: style,
    className: classNames
  }, children);
};
Column.styleRoot = 'Column';
Column.defaultProps = {
  mobile: COLUMNS,
  tablet: null,
  laptop: null,
  desktop: null,
  desktopLarge: null,
  phone: null,
  small: null,
  medium: null,
  large: null,
  pushMobile: null,
  pushTablet: null,
  pushLaptop: null,
  pushDesktop: null,
  pushDesktopLarge: null,
  xsOffset: null,
  smOffset: null,
  mdOffset: null,
  lgOffset: null,
  dlgOffset: null,
  className: ''
};
export default inject(styles)(Column);